// src/components/deal-detail/CollapsibleSection.jsx
// Reusable collapsible header used by the Deal Summary + Seller Form +
// Buyer Form so the team can hide whole sections they don't need to
// look at on a given deal (e.g. collapse "Pre-Listing" once the property
// is Under Contract). The header acts as the toggle; clicking anywhere
// on the row expands or collapses the children.

import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function CollapsibleSection({
  title,
  defaultOpen = true,
  className = "",
  headerClassName = "mt-5 mb-2",
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`w-full flex items-center justify-between text-left ${headerClassName} group`}
        aria-expanded={open}
      >
        <h4 className="text-base font-semibold text-slate-900 group-hover:text-slate-700 transition">
          {title}
        </h4>
        <ChevronDown
          size={16}
          strokeWidth={2.5}
          className={`text-slate-400 group-hover:text-slate-600 transition-transform ${
            open ? "" : "-rotate-90"
          }`}
        />
      </button>
      {open && <div>{children}</div>}
    </div>
  );
}
